import { Link } from 'react-router-dom';
import { categories } from '@/mocks/posts';

const iconMap: Record<string, string> = {
  'ri-heart-line': 'ri-heart-line',
  'ri-chat-smile-2-line': 'ri-chat-smile-2-line',
  'ri-palette-line': 'ri-palette-line',
  'ri-book-open-line': 'ri-book-open-line',
  'ri-briefcase-line': 'ri-briefcase-line',
  'ri-question-answer-line': 'ri-question-answer-line',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索社区分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            六大内容分类，总有一个适合你。选择感兴趣的方向，开启你的社区之旅。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-6 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${iconMap[cat.icon] || cat.icon} text-xl text-accent-500 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 mb-3 leading-relaxed">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.postCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}